<script>
  import { fade } from "svelte/transition";
  import copy from "../data/doc.json";
  import touch from "../svg/touch.svg";
  import { showPopup, progress, selectedAudience } from "../stores/global.js";
  import dragHorizontal from "../svg/drag-horizontal.svg";
  import swipeVertical from "../svg/swipe-vertical.svg";
  export let name;

  const text = copy.tips[name];
</script>

<div transition:fade class="guide {name}">
  <p>{text}</p>
  <span>
    {#if name === "show"}
      {@html touch}
    {:else if name === "scroll"}
      {@html swipeVertical}
    {:else if name === "audience"}
      {@html dragHorizontal}
    {/if}
  </span>
</div>

<style>
  .guide {
    position: absolute;
    width: 16em;
    z-index: var(--z-overlay);
    background-color: var(--base-gray-dark);
    color: var(--base-white);
    box-shadow: 0 0 5px 10px rgba(0, 0, 0, 0.75);
    padding: 0.25em 1em;
    font-size: 16px;
  }

  .guide.show {
    top: 50%;
    left: 50%;
    transform: translate(-135%, -160%);
  }

  .guide.scroll {
    top: 5em;
    right: 10em;
  }

  .guide.audience {
    bottom: 10em;
    left: 50%;
    transform: translate(-50%, 0);
  }

  .guide span {
    display: block;
    position: absolute;
    width: 1.5em;
    height: 1.5em;
    transform-origin: center center;
  }

  .guide.show span {
    right: -3em;
    bottom: -3em;
    transform: rotate(135deg);
  }

  .guide.scroll span {
    right: -3em;
    top: 50%;
    transform: translate(0, -50%);
  }

  .guide.audience span {
    left: 50%;
    bottom: -2em;
    transform: translate(-50%, 0);
  }

  @media only screen and (max-width: 640px) {
    .guide.show {
      top: 30%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .guide.show span {
      right: 50%;
      bottom: -3em;
      transform: rotate(135deg);
    }

    .guide.scroll {
      top: 60%;
      left: 50%;
      right: auto;
      transform: translate(-50%, -50%);
    }

    .guide.audience {
      opacity: 0;
      pointer-events: none;
    }
  }
</style>
